import { Component, Input, OnInit, inject } from "@angular/core";
import { HvacService } from "../../core/hvac.service";
import { GenericSystem } from "../../../../../codegen/out/types";

@Component({
  selector: "app-system-grid",
  templateUrl: "./system-grid.component.html",
  styleUrls: ["./system-grid.component.scss"],
  standalone: false,
})
export class SystemGridComponent implements OnInit {
  private hvacService = inject(HvacService);

  @Input() systems: GenericSystem[];

  columnsToDisplay = [
    "id",
    "manufacturers",
    "thumbnail",
    "modelName",
    "verboseNames",
    "interfaces",
    "yellowFlags",
    "actions",
  ];

  ngOnInit() {}

  getSystemUrl(system: any): string {
    return this.hvacService.getSystemUrl(system.id);
  }
}
